import { formatPostalCode } from 'src/utils';
import { AddressDataProps } from '..';

export const getAddressReplaceText = (addressData: AddressDataProps): { [key: string]: string } => {
  return {
    '{postalCode}': formatPostalCode(addressData?.postalCode),
    '{houseNumber}': addressData?.houseNumber,
    '{houseNumberAddition}': addressData?.houseNumberAddition ?? '',
    '{places}': addressData?.city ?? '',
  };
};

